import React from 'react';
import { Svg, SvgProps } from '@utex/ui-kit';

export const IconFeed = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} {...props}>
    <path d="M21.872 14.648c-.285-.371-.619-.693-.94-1.015-.805-.742-1.733-1.274-2.513-2.054-1.807-1.807-2.203-4.79-1.052-7.079-1.114.285-2.166.928-3.032 1.634-3.143 2.574-4.381 7.116-2.896 11.014.05.124.1.247.1.408 0 .273-.187.52-.434.62-.272.123-.57.049-.792-.15a1.027 1.027 0 01-.186-.21c-1.361-1.77-1.584-4.306-.656-6.336-2.03 1.683-3.106 4.53-2.957 7.215.05.619.123 1.238.334 1.856.173.743.495 1.485.89 2.141 1.288 2.141 3.553 3.676 5.99 3.985 2.6.334 5.384-.148 7.377-1.98 2.227-2.054 3.032-5.321 1.856-8.168l-.161-.322a6.898 6.898 0 00-.965-1.546l.037-.013zm-3.837 7.797c-.346.297-.903.619-1.336.742-1.362.47-2.723-.198-3.564-1.015 1.485-.346 2.351-1.435 2.598-2.537.21-.99-.173-1.806-.334-2.76-.148-.915-.123-1.695.248-2.549.185.47.433.94.718 1.312.94 1.238 2.413 1.782 2.722 3.465.05.174.075.347.075.532.037 1.015-.396 2.13-1.139 2.797l.012.013z" />
  </Svg>
);

export const IconIdeas = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} {...props}>
    <path
      fillRule="evenodd"
      d="M15.5 3.5a9 9 0 00-9 9c0 5 4 7 6 11h6c2-4 6-6 6-11a9 9 0 00-9-9zm0 3v5h4l-4 7v-5h-4l4-7zm-3 19v1a2 2 0 002 2 1 1 0 002 0 2 2 0 002-2v-1h-6z"
    />
  </Svg>
);

export const IconCase = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} {...props}>
    <path d="M14.5 4a2 2 0 00-2 2h-7a2 2 0 00-2 2v8a2 2 0 002 2h20a2 2 0 002-2V8a2 2 0 00-2-2h-7a2 2 0 00-2-2h-2zm1 10a1 1 0 110 2 1 1 0 010-2zm-12 5.443V23a2 2 0 002 2h20a2 2 0 002-2v-3.557a3.96 3.96 0 01-2 .557h-20a3.96 3.96 0 01-2-.557z" />
  </Svg>
);

export const IconHelp = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} {...props}>
    <path d="M28 14.6244C28 9.04253 22.673 4.5 16.1266 4.5C9.57927 4.5 4.25288 9.04253 4.25288 14.6244C4.25288 15.715 4.46642 16.8069 4.88842 17.8661C5.37832 19.6907 5.86314 22.9665 4 25.5C4.63268 25.4314 7.47562 25.0448 9.77314 23.4884L10.0343 23.312L10.3179 23.4477C12.0878 24.298 14.0962 24.7491 16.1266 24.7491C22.673 24.7491 28 20.2062 28 14.6244Z" />
  </Svg>
);

